import type { RouteObject } from "react-router-dom";
import { helperPathname, pathname } from "#src/config/pathname";

import {
  workspaceDetailsLoader,
  WorkspaceDetailsPage,
} from "#src/pages/workspace/details";
import WorkspaceSecurityPage from "#src/pages/workspace/security";
import WorkspaceMembersPage from "#src/pages/workspace/members";
import WorkspaceActivityLogsPage from "#src/pages/workspace/activityLogs";
import WorkspaceBillingPage from "#src/pages/workspace/billing";
import WorkspaceBillingRenewSubscriptionPage from "#src/pages/workspace/billing/renew";
import WorkspaceBillingUpgradeTrustCenter from "#src/pages/workspace/billing/upgrade/trustCenter";
import WorkspaceBillingUpgradeTcCustomDomain from "#src/pages/workspace/billing/upgrade/trustCenter/customDomain";
import { BillingSolutionTab } from "#src/pages/workspace/billing/solution";
import { BillingOrderTab } from "#src/pages/workspace/billing/order";
import { BillingContractTab } from "#src/pages/workspace/billing/contract";
import { BillingConfigTab } from "#src/pages/workspace/billing/config";

export const workspaceRoute: RouteObject = {
  path: helperPathname.WORKSPACE,
  children: [
    {
      path: pathname.WORKSPACE_DETAILS,
      loader: workspaceDetailsLoader,
      element: <WorkspaceDetailsPage />,
    },
    {
      path: pathname.WORKSPACE_SECURITY,
      loader: workspaceDetailsLoader,
      element: <WorkspaceSecurityPage />,
    },
    {
      path: pathname.WORKSPACE_MEMBERS,
      element: <WorkspaceMembersPage />,
    },
    {
      path: pathname.WORKSPACE_ACTIVITY_LOGS,
      element: <WorkspaceActivityLogsPage />,
    },
    {
      path: helperPathname.WORKSPACE_BILLING,
      element: <WorkspaceBillingPage />,
      children: [
        {
          path: pathname.WORKSPACE_BILLING_SOLUTIONS,
          element: <BillingSolutionTab />,
        },
        {
          path: pathname.WORKSPACE_BILLING_ORDERS,
          element: <BillingOrderTab />,
        },
        {
          path: pathname.WORKSPACE_BILLING_CONTRACTS,
          element: <BillingContractTab />,
        },
        {
          path: pathname.WORKSPACE_BILLING_SETTINGS,
          element: <BillingConfigTab />,
        },
      ],
    },
    {
      path: pathname.WORKSPACE_BILLING_RENEW,
      element: <WorkspaceBillingRenewSubscriptionPage />,
    },
    {
      path: pathname.WORKSPACE_BILLING_UPGRADE_TRUST_CENTER,
      element: <WorkspaceBillingUpgradeTrustCenter />,
    },
    {
      path: pathname.WORKSPACE_BILLING_UPGRADE_TC_CUSTOM_DOMAIN,
      element: <WorkspaceBillingUpgradeTcCustomDomain />,
    },
  ],
};
